/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { SearchQueryDocumentList } from '../models/search-query-document-list';
import { searchQueryGetSearchQueryDocumentList } from '../fn/search-query/search-query-get-search-query-document-list';
import { SearchQueryGetSearchQueryDocumentList$Params } from '../fn/search-query/search-query-get-search-query-document-list';

@Injectable({ providedIn: 'root' })
export class SearchQueryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchQueryGetSearchQueryDocumentList()` */
  static readonly SearchQueryGetSearchQueryDocumentListPath = '/search-query/{searchQueryId}/document/list';

  /**
   * Get search query documents.
   *
   * Get search query documents
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchQueryGetSearchQueryDocumentList()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchQueryGetSearchQueryDocumentList$Response(params: SearchQueryGetSearchQueryDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchQueryDocumentList>> {
    const obs = searchQueryGetSearchQueryDocumentList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get search query documents.
   *
   * Get search query documents
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchQueryGetSearchQueryDocumentList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchQueryGetSearchQueryDocumentList(params: SearchQueryGetSearchQueryDocumentList$Params, context?: HttpContext): Observable<SearchQueryDocumentList> {
    const resp = this.searchQueryGetSearchQueryDocumentList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SearchQueryDocumentList>): SearchQueryDocumentList => r.body)
    );
  }

}
